module.exports = __webpack_public_path__ + "img/0Q3B7249_Foamcore_MockedUp.44689e7e.jpg";